import * as React from 'react';
import styles from './info-banner.scss';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';

export interface InfoBannerProps {
  textTitle?: string;
  textDescription?: string;
  children?: any;
  iconUrl?: string;
  className?: string;
}

export const InfoBanner = (props: InfoBannerProps) => (
  <div className={`main-grid ${styles.infoBanner} ${props.className || ''}`}>
    {props.iconUrl && <div className={`${styles.infoImage}`}>
      <img src={toAbsoluteUrl(props.iconUrl)} />
    </div>}
    <div>
      <h2 className={styles.bannerTitle}>{props.textTitle}</h2>
      <div className={styles.bannerDescription}>
        {props.textDescription}
        {props.children}
      </div>
    </div>
  </div>
);

export const ConfidentialBanner = (props: InfoBannerProps) => 
  <InfoBanner {...props} iconUrl="i/confidential_icon.svg" />;

export const CasePasswordBanner = (props: InfoBannerProps) =>
  <InfoBanner {...props} iconUrl="i/case-receipt-checkbox.svg" className={styles.casePasswordBanner} />;
